<svg
  width="100%"
  height="345"
  viewBox="0 0 308 345"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M122.731 115.822L-130.731 116C-136.403 116 -141 113.987 -141 111.507V20.6718C-141 18.1878 -136.403 16.1784 -130.731 16.1784L122.731 16C128.403 16 133 18.0128 133 20.4934V111.328C133 113.812 128.403 115.822 122.731 115.822Z"
    fill="#362C7B"
  />
  <g filter="url(#filter0_di_956_6)">
    <path
      d="M-71.4781 45.9619L133 45.7844V31.1152L-71.4781 31.2927C-76.6115 31.2927 -80.7734 33.2955 -80.7734 35.7638V41.4875C-80.7734 43.9591 -76.6115 45.9585 -71.4781 45.9585V45.9619Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask0_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="-81"
      y="31"
      width="214"
      height="15"
    >
      <path
        d="M-71.48 45.9619L132.998 45.7844V31.1152L-71.48 31.2927C-76.6135 31.2927 -80.7754 33.2955 -80.7754 35.7638V41.4875C-80.7754 43.9591 -76.6135 45.9585 -71.48 45.9585V45.9619Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_956_6)">
      <path
        d="M88.5104 64.6332L152.701 33.5635L145.022 27.3174L80.832 58.3871L88.5104 64.6332Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter1_di_956_6)">
    <path
      d="M-71.4781 74.4062L133 74.2287V59.5596L-71.4781 59.7371C-76.6115 59.7371 -80.7734 61.7398 -80.7734 64.2081V69.9318C-80.7734 72.4034 -76.6115 74.4029 -71.4781 74.4029V74.4062Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask1_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="-81"
      y="59"
      width="214"
      height="16"
    >
      <path
        d="M-71.48 74.4052L132.998 74.2277V59.5586L-71.48 59.7361C-76.6135 59.7361 -80.7754 61.7389 -80.7754 64.2072V69.9308C-80.7754 72.4025 -76.6135 74.4019 -71.48 74.4019V74.4052Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_956_6)">
      <path
        d="M96.6643 102.851L164.394 70.0632L141.904 51.7637L74.1738 84.5515L96.6643 102.851Z"
        fill="#FEAC18"
      />
      <path
        d="M42.3234 89.8598L106.514 58.7901L98.8353 52.5439L34.6484 83.6137L42.3234 89.8598Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter2_di_956_6)">
    <path
      d="M-71.4797 102.803L133 102.625V87.9561L-71.4797 88.1335C-76.6123 88.1335 -80.7734 90.1363 -80.7734 92.6046V98.3283C-80.7734 100.8 -76.6123 102.799 -71.4797 102.799V102.803Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask2_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="-81"
      y="87"
      width="214"
      height="16"
    >
      <path
        d="M-71.4816 102.803L132.998 102.625V87.9561L-71.4816 88.1335C-76.6142 88.1335 -80.7754 90.1363 -80.7754 92.6046V98.3283C-80.7754 100.8 -76.6142 102.799 -71.4816 102.799V102.803Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_956_6)">
      <path
        d="M73.9138 157.975L179.742 106.737L121.828 59.6113L16 110.846L73.9138 157.975Z"
        fill="#FEAC18"
      />
      <path
        d="M-12.7077 114.188L51.4714 83.1182L43.7943 76.8721L-20.3848 107.942L-12.7077 114.188Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <path
    d="M262.731 234.822L9.26876 235C3.59665 235 -1 232.987 -1 230.507V139.672C-1 137.188 3.59665 135.178 9.26876 135.178L262.731 135C268.403 135 273 137.013 273 139.493V230.328C273 232.812 268.403 234.822 262.731 234.822Z"
    fill="#362C7B"
  />
  <g filter="url(#filter3_di_956_6)">
    <path
      d="M68.5219 164.962L273 164.784V150.115L68.5219 150.293C63.3885 150.293 59.2266 152.296 59.2266 154.764V160.487C59.2266 162.959 63.3885 164.959 68.5219 164.959V164.962Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask3_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="59"
      y="150"
      width="214"
      height="15"
    >
      <path
        d="M68.52 164.962L272.998 164.784V150.115L68.52 150.293C63.3865 150.293 59.2246 152.296 59.2246 154.764V160.487C59.2246 162.959 63.3865 164.959 68.52 164.959V164.962Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_956_6)">
      <path
        d="M228.51 183.633L292.701 152.563L285.022 146.317L220.832 177.387L228.51 183.633Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter4_di_956_6)">
    <path
      d="M68.5219 193.406L273 193.229V178.56L68.5219 178.737C63.3885 178.737 59.2266 180.74 59.2266 183.208V188.932C59.2266 191.403 63.3885 193.403 68.5219 193.403V193.406Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask4_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="59"
      y="178"
      width="214"
      height="16"
    >
      <path
        d="M68.52 193.405L272.998 193.228V178.559L68.52 178.736C63.3865 178.736 59.2246 180.739 59.2246 183.207V188.931C59.2246 191.402 63.3865 193.402 68.52 193.402V193.405Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_956_6)">
      <path
        d="M236.664 221.851L304.394 189.063L281.904 170.764L214.174 203.552L236.664 221.851Z"
        fill="#FEAC18"
      />
      <path
        d="M182.323 208.86L246.514 177.79L238.835 171.544L174.648 202.614L182.323 208.86Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter5_di_956_6)">
    <path
      d="M68.5203 221.803L273 221.625V206.956L68.5203 207.134C63.3877 207.134 59.2266 209.136 59.2266 211.605V217.328C59.2266 219.8 63.3877 221.799 68.5203 221.799V221.803Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask5_956_6"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="59"
      y="206"
      width="214"
      height="16"
    >
      <path
        d="M68.5184 221.803L272.998 221.625V206.956L68.5184 207.134C63.3858 207.134 59.2246 209.136 59.2246 211.605V217.328C59.2246 219.8 63.3858 221.799 68.5184 221.799V221.803Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_956_6)">
      <path
        d="M213.914 276.975L319.742 225.737L261.828 178.611L156 229.846L213.914 276.975Z"
        fill="#FEAC18"
      />
      <path
        d="M127.292 233.188L191.471 202.118L183.794 195.872L119.615 226.942L127.292 233.188Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <path
    d="M147.593 344.838L-84.5932 345C-89.7892 345 -94 343.168 -94 340.911V258.251C-94 255.991 -89.7892 254.162 -84.5932 254.162L147.593 254C152.789 254 157 255.832 157 258.089V340.749C157 343.009 152.789 344.838 147.593 344.838Z"
    fill="#362C7B"
  />
  <path
    d="M-30.3616 280.826L157.001 280.663V267.222L-30.3616 267.384C-35.0654 267.384 -38.8789 269.219 -38.8789 271.481V276.726C-38.8789 278.99 -35.0654 280.823 -30.3616 280.823V280.826Z"
    fill="#FFBF4B"
  />
  <mask
    id="mask6_956_6"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="-39"
    y="267"
    width="196"
    height="14"
  >
    <path
      d="M-30.3655 280.826L156.997 280.663V267.222L-30.3655 267.384C-35.0693 267.384 -38.8828 269.219 -38.8828 271.481V276.726C-38.8828 278.99 -35.0693 280.823 -30.3655 280.823V280.826Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask6_956_6)">
    <path
      d="M116.233 297.934L175.05 269.464L168.015 263.741L109.197 292.21L116.233 297.934Z"
      fill="#FEAC18"
    />
  </g>
  <path
    d="M-30.3616 306.887L157.001 306.724V293.283L-30.3616 293.446C-35.0654 293.446 -38.8789 295.281 -38.8789 297.543V302.787C-38.8789 305.052 -35.0654 306.884 -30.3616 306.884V306.887Z"
    fill="#FFBF4B"
  />
  <mask
    id="mask7_956_6"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="-39"
    y="293"
    width="196"
    height="14"
  >
    <path
      d="M-30.3655 306.888L156.997 306.725V293.284L-30.3655 293.447C-35.0693 293.447 -38.8828 295.282 -38.8828 297.544V302.788C-38.8828 305.053 -35.0693 306.885 -30.3655 306.885V306.888Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask7_956_6)">
    <path
      d="M123.704 332.953L185.765 302.909L165.157 286.142L103.096 316.185L123.704 332.953Z"
      fill="#FEAC18"
    />
    <path
      d="M73.9115 321.05L132.729 292.581L125.693 286.857L66.8789 315.327L73.9115 321.05Z"
      fill="#FEAC18"
    />
  </g>
  <path
    d="M-30.3631 332.908L157.001 332.745V319.304L-30.3631 319.466C-35.066 319.466 -38.8789 321.301 -38.8789 323.563V328.808C-38.8789 331.072 -35.066 332.905 -30.3631 332.905V332.908Z"
    fill="#FFBF4B"
  />
  <mask
    id="mask8_956_6"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="-39"
    y="319"
    width="196"
    height="14"
  >
    <path
      d="M-30.367 332.908L156.997 332.745V319.304L-30.367 319.466C-35.0699 319.466 -38.8828 321.301 -38.8828 323.563V328.808C-38.8828 331.072 -35.0699 332.905 -30.367 332.905V332.908Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask8_956_6)">
    <path
      d="M102.861 383.463L199.831 336.514L146.765 293.333L49.7949 340.279L102.861 383.463Z"
      fill="#FEAC18"
    />
    <path
      d="M23.4895 343.342L82.2966 314.873L75.2622 309.149L16.4551 337.619L23.4895 343.342Z"
      fill="#FEAC18"
    />
  </g>
  <defs>
    <filter
      id="filter0_di_956_6"
      x="-115.773"
      y="0.115234"
      width="283.773"
      height="84.8467"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
    <filter
      id="filter1_di_956_6"
      x="-115.773"
      y="28.5586"
      width="283.773"
      height="84.8477"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
    <filter
      id="filter2_di_956_6"
      x="-114.773"
      y="57.9561"
      width="281.773"
      height="82.8467"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
    <filter
      id="filter3_di_956_6"
      x="24.2266"
      y="119.115"
      width="283.773"
      height="84.8467"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
    <filter
      id="filter4_di_956_6"
      x="24.2266"
      y="147.559"
      width="283.773"
      height="84.8477"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
    <filter
      id="filter5_di_956_6"
      x="25.2266"
      y="176.956"
      width="281.773"
      height="82.8467"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_6" />
    </filter>
  </defs>
</svg>
